import { jsx as _jsx } from "react/jsx-runtime";
import { formatCurrency } from '@/core/localization';
import { getBalanceColor } from '@/shared/helpers';
import { Typography } from '@mui/material';
export const BalanceColored = ({ balance }) => {
    return (_jsx(Typography, { sx: ({ palette }) => ({ color: getBalanceColor(balance, palette).main }), children: formatCurrency(balance) }));
};
